import { useTranslation } from 'react-i18next'
import HomeOverviewGridCard from './HomeOverviewGridCard'
import { useParams } from 'react-router'
import SliderDiamondSponsorsLogos from '../../../features/sponsors/components/silders/SliderDiamondSponsorsLogos'
import SliderGoldSponsorsLogos from '../../../features/sponsors/components/silders/SliderGoldSponsorsLogos'
import { Link } from 'react-router-dom'
import SliderGoldSponsorsBanners from '../../../features/sponsors/components/banners/SliderGoldSponsorsBanners'

export default function HomeOverviewSection() {
  const { t } = useTranslation()
  const { lng } = useParams()
  return (
    <div className="app-container flex flex-col gap-8 pt-16">
      <SliderGoldSponsorsBanners />
      <div className="grid grid-cols-12 gap-8 px-8 lg:px-0">
        <HomeOverviewGridCard
          image={'/assets/images/overview/arab-production.webp'}
          title={t('ARAB_PRODUCTION')}
          clean_energy_item={{
            link: `/${lng}/future-minerals/clean-energy/arab-production`,
            label: t('CLEAN_ENERGY_MINERALS'),
          }}
          industrial_item={{
            link: `/${lng}/future-minerals/industrial/arab-production`,
            label: t('INDUSTRIAL_MINERALS'),
          }}
          security_item={{
            link: `/${lng}/future-minerals/security/arab-production`,
            label: t('FOOD_SECURITY_MINERALS'),
          }}
          icon={'/assets/icons/overview/power-bi-icon.svg'}
        />
        <HomeOverviewGridCard
          image={'/assets/images/overview/value-chain.webp'}
          title={t('VALUE_CHAIN')}
          clean_energy_item={{
            link: `/${lng}/future-minerals/value-chains?category=1`,
            label: t('CLEAN_ENERGY_MINERALS'),
          }}
          industrial_item={{
            link: `/${lng}/future-minerals/value-chains?category=2`,
            label: t('INDUSTRIAL_MINERALS'),
          }}
          security_item={{
            link: `/${lng}/future-minerals/value-chains?category=4`,
            label: t('FOOD_SECURITY_MINERALS'),
          }}
          icon={'/assets/icons/overview/value-chain-icon.svg'}
        />
        <HomeOverviewGridCard
          image={'/assets/images/overview/global-demand.webp'}
          title={t('GLOBAL_DEMAND')}
          clean_energy_item={{
            link: `/${lng}/future-minerals/clean-energy/global-demand`,
            label: t('CLEAN_ENERGY_MINERALS'),
          }}
          industrial_item={{
            link: null,
            label: t('INDUSTRIAL_MINERALS'),
          }}
          security_item={{
            link: null,
            label: t('FOOD_SECURITY_MINERALS'),
          }}
          icon={'/assets/icons/overview/power-bi-icon.svg'}
        />
        <HomeOverviewGridCard
          image={'/assets/images/overview/clean-energy-technologies.webp'}
          title={t('TECHNOLOGIES_INDUSTRIES_APPLICATIONS')}
          clean_energy_item={{
            link: `/${lng}/future-minerals/clean-energy/technologies`,
            label: t('TECHNOLOGIES'),
          }}
          industrial_item={{
            link: `/${lng}/future-minerals/industrial/industries`,
            label: t('INDUSTRIES'),
          }}
          security_item={{
            link: `/${lng}/future-minerals/security/securities`,
            label: t('APPLICATIONS'),
          }}
          icon={'/assets/icons/overview/clean-energy-technologies-icon.svg'}
        />
      </div>
      <SliderDiamondSponsorsLogos />
      <SliderGoldSponsorsLogos />
      <div className="w-full">
        <div className="relative w-full group animate-pulse">
          <div className="absolute left-0 top-0 scale-50 animate-ping bg-secondary-600 p-2 delay-200 duration-700"></div>
          <div className="absolute right-0 top-0 scale-50 animate-ping bg-secondary-600 p-2 delay-200 duration-700"></div>
          <div className="absolute bottom-0 left-0 scale-50 animate-ping bg-secondary-600 p-2 delay-200 duration-700"></div>
          <div className="absolute bottom-0 right-0 scale-50 animate-ping bg-secondary-600 p-2 delay-200 duration-700"></div>
          <Link
            to={`/${lng}/sponsors/pricing`}
            className="relative w-full items-center justify-center flex bg-secondary-600 px-4 py-2 text-xl font-bold text-white hover:bg-secondary-700"
          >
            {t('To_sponsor')}
          </Link>
        </div>
      </div>
    </div>
  )
}
